import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  name: () => faker.lorem.word(),
  notes: null,
  enabled: true,

  afterCreate(feature, server) {
    const mapFloor = server.schema.mapFloors.first();
    const createdFeature = server.create('map-feature', {
      mapFloor,
      type: feature.type.split('_').join('-').toLowerCase(),
      name: feature.name,
      geometry: {
        type: 'Point',
        coordinates: [
          faker.number.float({ min: 0, max: 0.5, precision: 0.0001 }),
          faker.number.float({ min: 0, max: 1, precision: 0.0001 }),
        ],
      },
    });

    feature.update({
      id: createdFeature.id,
    });
  },
});
